.root {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  min-height: 80px;
  outline: none;
  padding: 8px 12px;
  resize: vertical;
  transition: border-color 0.15s;
  width: 100%;

  &:focus {
    border-color: var(--color-focus);
    box-shadow: 0 0 0 2px var(--color-focus);
  }

  &::placeholder {
    color: var(--color-placeholder);
  }

  &:disabled {
    background: var(--color-secondary);
    cursor: not-allowed;
    opacity: 0.6;
  }
}
